import React, { Fragment } from 'react';

import Board from './Board';

const TicTacToe = () => {
  return (
    <Fragment>
      <Board />
    </Fragment>
  )
}

export default TicTacToe